export class FileHelper {
    public static formatFileSize(sizeInBytes?: number): string {
        if (typeof sizeInBytes !== 'number') {
            return '0';
        }
        if (sizeInBytes >= 1024 * 1024 * 1024) {
            return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
        }
        if (sizeInBytes >= 1024 * 1024) {
            return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
        }
        return (sizeInBytes / 1024).toFixed(2) + ' KB';
    }
}
